import GuestLayout from '@/layouts/GuestLayout.vue';

const routes = [
  {
    path: '/error/not-found',
    component: GuestLayout,
    children: [
      {
        path: '',
        name: 'not-found',
        component: () => import('@/pages/NotFoundPage.vue')
      }
    ]
  }
];

export default routes;
